import { ProductAndRiderDetailsService } from "./ProductAndRiderDetailsService";
import * as Rental from "../RiderDetails/RiderDetailsModule";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { RentalAllowedStatus } from "../../../Models/Rental/RentalAllowedStatus";

export class CheckAllowedRentalIItemsService {
    private riderDetailsModule: Rental.RiderDetailsModule;
    private static instance: CheckAllowedRentalIItemsService;

    private constructor() {
        this.riderDetailsModule = AxLoad.GetModule<Rental.RiderDetailsModule>("RiderDetailsModule");
    }

    public static getInstance(): CheckAllowedRentalIItemsService {
        if (!CheckAllowedRentalIItemsService.instance) {
            CheckAllowedRentalIItemsService.instance = new CheckAllowedRentalIItemsService();
        }
        return CheckAllowedRentalIItemsService.instance;
    }

    public async checkIfItemIsAllowedForPerson(customerAccountNr: number): Promise<RentalAllowedStatus> {
        try {
            const productAndRiderDetails = ProductAndRiderDetailsService.getInstance()
                .getProductAndRiderDetails(this.riderDetailsModule.getAllProductInfoPortlets());

            const rentalItemId = this.riderDetailsModule
                .getActiveProductPortlet()
                .getProductAndRiderDetails()
                .productTripleWithType.id;

            const customerSelectedItems = productAndRiderDetails
                .filter(x => x.customerAccountNr === customerAccountNr)
                .map(x => (x.productTripleWithType.id));

            const data = {
                CustomerAccountNr: customerAccountNr,
                RentalItemId: rentalItemId,
                CustomerSelectedItems: customerSelectedItems,
            };

            const url = `/api/CheckAllowedRentalIItemsApi/CheckAllowedRentalItemsForPerson`;

            return new Promise<RentalAllowedStatus>((resolve, reject) => {
                AxessViewer.ajaxRequest(url, data,
                    (res) => {
                        const rentalAllowedStatus = new RentalAllowedStatus(res.RentalItemId, res.IsAllowed, res.ErrorMessage);
                        resolve(rentalAllowedStatus);
                    },
                    {
                        type: 'Post'
                    });
            });
        } catch (error) {
            console.error('Error checking item allowance:', error);
            throw error;
        }
    }
}